import { Alert, Button, Space } from "antd";

const SaveOverwriteAlert = () => {
  return (
    <Alert
      message="You're editing an older version of this report. Saving now could overwrite someone else's updates."
      type="warning"
      showIcon
      action={
        <Space>
          <Button
            onClick={() => {
              window.location.reload();
            }}
          >
            Refresh
          </Button>
        </Space>
      }
      closable={false}
    />
  );
};

export default SaveOverwriteAlert;
